module.exports = __webpack_public_path__ + "img/soundStart.669cffa7.png";